














import { useLog } from '@/common/log';
import { Maybe, Feed } from '@/generated-models';
import {
    computed,
    defineComponent,
    onMounted,
    PropType,
} from '@vue/composition-api';
export default defineComponent({
    props: {
        info: {
            type: Object as PropType<Maybe<Feed>>,
        },
    },
    setup(props) {
        const log = useLog();
        const authorName = computed(() => `@${props.info?.author?.name}`);
        const caption = computed(() => props.info?.photo?.caption || '');
        const profileUrl = computed(() => `/profile/${props.info?.author?.id}`);
        const tags = computed(() => props.info?.tags || []);
        function handleClick(e: any) {
            if (e && e.srcElement?.innerText) {
                // 获取当前点击的 a 标签的文案，因为这个hashtag是前端动态parse文案然后，拼接的 a 标签，所以通过点击element来获取文案
                const hashText = e.srcElement?.innerText.split('#')[1] || '';
                if (hashText) {
                    log({
                        type: 'CLICK',
                        event_name: 'HASHTAG_BUTTON',
                        event_value: {
                            button_name: e.srcElement?.innerText.split('#')[1],
                        },
                    });
                }
            }
        }
        onMounted(() => {
            tags.value.forEach(tag => {
                log({
                    type: 'SHOW',
                    event_name: 'HASHTAG_BUTTON',
                    event_value: {
                        button_name: tag,
                    },
                });
            });
        });
        return {
            authorName,
            caption,
            profileUrl,
            handleClick,
        };
    },
});
